import { updateCurrentUser } from "firebase/auth";
import React from "react";
import {Card, Form, Button, Container } from "react-bootstrap";
import Copyright from "../Copyright";
import leadtubLogoBlack from '../../assets/logo/leadtubLogoBlack.png'
import LoadingLoginScreen from "../LoadingLoginScreen";
import { useAuth } from "../../contexts/AuthContext";
export const ConsentPage = () => {
    const {currentUser} = useAuth();
    const [loading, setLoading] = React.useState(false);
    
    const acceptTerms = async () => {
        console.log(currentUser);        
    };

    return(
        <Container fluid
        className="d-flex align-items-center justify-content-center"
        style={{minHeight: "100vh", minWidth: '100%', backgroundColor: '#414141'}}
>
 {loading ?
     <LoadingLoginScreen/> : <React.Fragment/>
 }
 <Card>
     <Card.Body>
         <img style={{
             display: 'block',
             marginLeft: "auto",
             marginRight: "auto"
         }}
              alt="Logo" className="text-center mb-4" src={leadtubLogoBlack}/>



         <h4 className="text-center mb-4">Godkänn Användarvillkor</h4>
             <Button disabled={loading} className="w-100" onClick={() => acceptTerms()}>
                Godkänn Användarvillkor
             </Button>
         
        
     </Card.Body>
     <Copyright/>
 </Card>

</Container>
    )
}